import React from 'react';
import { Grid, Popover, Stack, Typography } from '@mui/material';
import styles from 'custom/style.module.css';
import flightStyles from '../flightsfolder.module.css';
import { PopoverHead, PopoverContent, CustomButton, InputProps, CustomTextField } from 'custom/components';
import CloseIcon from '@mui/icons-material/Close';

const NoOpRemarkModal = (props) => {
  const { popup, anchorEl, remark, onChange, handleOk, handleClose } = props;
  return (
    <div>
      <Popover
        open={popup}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{ paper: { className: flightStyles.popoverWidth, } }}
      >
        <PopoverHead>
          <Stack direction='column'>
            <Typography variant='subtitle1' component='span' fontWeight={'bold'} 
            >Non Operational Remark</Typography>
          </Stack>
          <CloseIcon fontSize='small' className={styles.pointer} onClick={handleClose} />
        </PopoverHead>
        <PopoverContent className={styles.textCenter}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomTextField
                {...InputProps}
                id='remark'
                placeholder='Add Remark'
                multiline
                rows={4}
                maxRows={Infinity}
                name='remark'
                fullWidth
                inputProps={{ 'aria-label': 'remarks' }}
                variant='outlined'
                value={remark}
                onChange={onChange}
                className={`${styles.borderedIpTextfield} ${styles.remarkIpTextarea}`}
                InputProps={{
                  classes: {
                    root: `${styles.borderedIpRoot} ${styles.remarkIpRoot}`,
                    input: `${styles.borderedIp} ${styles.remarkIp}`,
                    notchedOutline: styles.notchedOutline,
                    error: styles.errorInput,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomButton variant='contained' size='small' className={styles.minWidth150} onClick={handleOk}>Submit</CustomButton>
            </Grid>
          </Grid>
        </PopoverContent>
      </Popover>
    </div>
  );
};
export default NoOpRemarkModal;